module.exports = __webpack_public_path__ + "img/member-first-col.38f6f0f8.svg";